import { WarehouseRepository } from "@infrastructure/repositories/warehouse-repository";

export class WarehouseGetByIdUseCase {
  constructor(private readonly warehouseRepository: WarehouseRepository) {}

  public async execute(id: string) {
    return await this.warehouseRepository.getFullDTOById(id);
  }
}
